var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccasion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9775 16.26C23.6625 15.495 22.785 15.1312 22.02 15.45L21.1912 15.795L19.74 11.9737C21.5362 10.6612 22.17 8.21248 21.0337 6.24373L17.7862 0.599983C17.4862 0.0787331 16.845 -0.138767 16.2862 0.0899831L12 1.86748L7.71372 0.0899831C7.15497 -0.142517 6.51372 0.0787331 6.21372 0.599983L2.96622 6.24373C1.83372 8.21248 2.46372 10.6612 4.25997 11.97L2.80872 15.7912L1.97997 15.4462C1.21497 15.1275 0.341217 15.4912 0.0224672 16.2562C-0.0412828 16.41 0.0299672 16.5862 0.183717 16.65L6.26997 19.1775C6.42372 19.2412 6.59622 19.17 6.65997 19.0162C6.97497 18.2512 6.61497 17.3737 5.84997 17.055L5.02122 16.71L6.49872 12.825C6.66372 12.8437 6.82872 12.8737 6.98997 12.8737C8.92872 12.8737 10.7175 11.6325 11.2425 9.67498L12 6.84748L12.7575 9.67498C13.2825 11.6325 15.0712 12.8737 17.01 12.8737C17.1712 12.8737 17.3362 12.8437 17.5012 12.825L18.975 16.71L18.1462 17.055C17.3812 17.3737 17.0175 18.2512 17.3362 19.0162C17.4 19.17 17.5762 19.2412 17.7262 19.1775L23.8162 16.65C23.9662 16.5862 24.0412 16.4137 23.9775 16.26ZM10.3462 6.07873L6.14247 4.33498L7.51122 1.95748L11.055 3.42748L10.3462 6.07873ZM13.6537 6.07873L12.945 3.42748L16.4887 1.95748L17.8575 4.33498L13.6537 6.07873Z",
    fill: "#495e57"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 19.2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccasion);
export default __webpack_public_path__ + "static/media/occasion.82f9b736c9d9601e15505e3a17c542bc.svg";
export { ForwardRef as ReactComponent };